import { useNavigate, useLocation } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";

import Img from "../../../assets/acg-logo.avif";

const MobileHeader = ({ theme }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNav = (page) => () => {
    window.scrollTo(0, 0);
    navigate(page);
  };

  const isLoginPage = location.pathname === "/";

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        bgcolor: "rgba(255,255,255,0.96)",
        color: "black",
        borderBottom: "1px solid",
        borderColor: "divider",
        backdropFilter: "blur(8px)",
      }}
    >
      <Toolbar sx={{ minHeight: 64, px: 2 }}>
        <Box
          sx={{
            width: 40,
            height: 40,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mr: 1.25,
          }}
        >
          <img
            src={Img}
            alt="ACG"
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        </Box>
        <Box sx={{ flexGrow: 1, minWidth: 0 }}>
          <Typography variant="subtitle1" noWrap sx={{ fontWeight: 700, lineHeight: 1.2 }}>
            ACG Sales Tool
          </Typography>
        </Box>
        {!isLoginPage ? (
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={handleNav("/")}
            theme={theme}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              borderRadius: "10px",
            }}
          >
            Login
          </Button>
        ) : null}
      </Toolbar>
    </AppBar>
  );
};

export default MobileHeader;
